export default "<div class=\"charts\">\n  \n</div>"